module.exports = __webpack_public_path__ + "img/calendar blue.6b36ac01.svg";